<template>
  <span>{{ option.text }}</span>
</template>
<script>
export default {
  props: ["option"],
}
</script>
